<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
         <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div id="deals" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px" >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Customer Account Details</b>
              </span>
            </nav>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <span class="col-form-label col-form-label-sm">Year:</span>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <select
                  class="form-control input-sm"
                  v-model.trim="year"
                  @change="getAccountListForMonthChange"
                >
                  <option value="All">All</option>
                  <option
                    v-for="status in dataYear"
                    v-bind:value="status"
                    v-bind:key="status"
                  >{{ status}}</option>
                </select>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <span class="col-form-label col-form-label-sm">Month:</span>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <select
                  class="form-control input-sm"
                  v-model.trim="month"
                  @change="getAccountListForMonthChange"
                >
                  <option value="All">All</option>
                  <option
                    v-for="(option) in dataMonth"
                    :value="option.text"
                    v-bind:key="option.text"
                  >{{option.month}}</option>
                </select>
              </div>

              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <span class="col-form-label col-form-label-sm">Customer Invitation Code : </span>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect
                  style="width:100%"
                  v-model="yodlee.accountid"
                  data-vv-as="Dealer"
                  :options="accountidlist"
                  :custom-label="customLabel"
                  selected="selected"
                  @input="getaccountidurl"
                ></multiselect>
              </div>
            </div>
            <center class="mb-2">
              <button type="submit" class="btn btn-secondary" @click="clearData">Reset</button>
            </center>

            <div v-if="yodlee.accountid !== ''">
              <div class="row p-2 justify-content-center">
                <div class="col">
                  <div class="table-responsive table-responsive-sm">
                    <table class="table table-sm table-bordered table-striped">
                      <thead>
                        <tr class="table-month-header-blue">
                          <th v-for="(head,index) in heads" :key="index">{{head.name}}</th>
                        </tr>
                      </thead>
                      <tr v-for="(data,index) in accounturllist" :key="index">
                        <td class="table-month-td">
                          <span
                            target="_blank"
                            @click="clickurl(data.downloadLink)"
                            :key="index"
                            class="reportLink"
                            title="Download pdf"
                            :src="data.downloadLink"
                          >{{urlList[index]}}</span>
                        </td>
                        <td class="table-month-td">{{data.dealId}}</td>
                        <td class="table-month-td">{{data.businessName}}</td>
                        <td class="table-month-td">{{data.info}}</td>
                        <td class="table-month-td">{{data.caEmail}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div></div>

            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Invite Customer To Verify Details</b>
              </span>
            </nav>
            <center>
              <span :style="msgcolor">{{ message }}</span>
            </center>
            <br />

            <div
              class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
            >
              <div
                class="col-12 col-lg-3 col-md-12 d-flex justify-content-start align-items-center ml-2 mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-model="yodlee.dealid"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label>Deal Id</label>
                </div>
              </div>
              <div class="col-12 col-lg-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="First Name"
                    v-model="yodlee.firstname"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label class="required">First Name</label>
                  <div
                    v-if="errors.has('First Name')"
                    class="alert-danger"
                  >{{ errors.first("First Name") }}</div>
                </div>
              </div>
            </div>

            <div
              class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
            >
              <div
                class="col-12 col-lg-3 col-md-12 d-flex justify-content-start align-items-center ml-2 mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-model="yodlee.middlename"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label>Middle Name</label>
                </div>
              </div>
              <div class="col-12 col-lg-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    data-vv-name="Last Name"
                    v-validate="'required'"
                    v-model="yodlee.lastname"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label class="required">Last Name</label>
                  <div
                    v-if="errors.has('Last Name')"
                    class="alert-danger"
                  >{{ errors.first("Last Name") }}</div>
                </div>
              </div>
            </div>

            <div
              class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
            >
              <div
                class="col-12 col-lg-3 col-md-12 d-flex justify-content-start align-items-center ml-2 mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-model="yodlee.businessname"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label>Business Name</label>
                </div>
              </div>
              <div class="col-12 col-lg-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="Email"
                    v-model="yodlee.email"
                    @blur="validateEmail"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label class="required">Email</label>
                  <div v-if="errors.has('Email')" class="alert-danger">{{ errors.first("Email") }}</div>
                </div>
              </div>
            </div>

            <div
              class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
            >
              <div
                class="col-12 col-lg-3 col-md-12 d-flex justify-content-start align-items-center ml-2 mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-model="yodlee.mobile"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label>Vehicle</label>
                </div>
              </div>
              <div class="col-12 col-lg-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <div class="input-group">
                  <input
                    class="floating-input"
                    type="text"
                    v-model="yodlee.zipcode"
                    placeholder="  "
                    @click="clearMessage"
                  />
                  <span class="highlight"></span>
                  <label>VIN</label>
                </div>
              </div>
            </div>

            <br />
            <center class="mb-5">
              <div>
                <button
                  type="submit"
                  class="btn btn-secondary mb-5"
                  @click="savecustomerdata"
                >Send Invite</button>
              </div>
            </center>
          </div>
          <div class="modal" id="myModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
              <div class="modal-content modal-height">
                <div class="modal-body">
                  <p>Work in progress, Please wait...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpyodlee from '../js/http-yodlee'

export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      msg: '',
      savedmessage: '',
      message: '',
      year: 'All',
      month: 'All',
      urllinks: true,
      yodleedatalist: [],
      accountidlist: [],
      accounturllist: [],
      displayAnalyticsFour: '',
      msgcolor: {
        color: 'black'
      },
      dataYear: [],
      dataMonth: [
				    { text: '1', month: 'Jan' },
				    { text: '2', month: 'Feb' },
				    { text: '3', month: 'Mar' },
				    { text: '4', month: 'Apr' },
				    { text: '5', month: 'May' },
				    { text: '6', month: 'Jun' },
				    { text: '7', month: 'Jul' },
				    { text: '8', month: 'Aug' },
				    { text: '9', month: 'Sep' },
				    { text: '10', month: 'Oct' },
				    { text: '11', month: 'Nov' },
				    { text: '12', month: 'Dec' }
      ],
      urlList: [],
      yodlee: this.initializedata(),
      heads: [{ name: 'DownloadLink' }, { name: 'Deal Id' }, { name: 'Business Name' }, { name: 'Info' }, { name: 'credit analyst email' }]
    }
  },

  mounted () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
  },
  methods: {
    clickurl (data) {
      window.open(data, '_target')
    },
    customLabel (option) {
      return `${option}`
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    initializedata () {
      return {
        firstname: '',
        lastname: '',
        mobile: '',
        email: '',
        message: '',
        middlename: '',
        zipcode: '',
        dealid: '',
        accountid: '',
        businessname: ''
      }
    },
    getkeymaster () {
      httpyodlee
        .get('/ydkeyvalues/getkeyvalues/' + 4)
        .then(response => {
          this.yodleedatalist = response.data
        })
        .catch(e => {
          this.errorslist.push(e)
        })
    },
    clearData () {
      this.year = new Date().getFullYear(),
      this.month = new Date().getMonth() + 1
      this.yodlee.accountid = ''
      this.accounturllist = []
    },
    getYears () {
      httpyodlee
        .get('/account/years')
        .then(response => {
          this.dataYear = response.data
        })
        .catch(e => {
          this.errorslist.push(e)
        })
      this.year = new Date().getFullYear(),
      this.month = new Date().getMonth() + 1
    },
    getaccountidurl () {
      this.urlList = []
      this.accounturllist = []
      var accountLength = this.yodlee.accountid.split('_').length
      var invitation = this.yodlee.accountid.split('_')[accountLength - 1]
      console.log('length of account Id : ' + invitation)
      var modal = document.getElementById('myModal')
      modal.style.display = 'block'
      httpyodlee
        .get('/account/s3Url/' + this.yodlee.accountid.split('_')[accountLength - 1] + '/' + this.$session.get('user_id'))
        .then(response => {
          this.urllinks = false
          this.accounturllist = response.data
          console.log('RETURN DATA : ' + JSON.stringify(this.accounturllist))
          for (var i = 0; i < this.accounturllist.length; i++) {
            var test = this.accounturllist[i].downloadLink
            var pdftest = test.split('?')[0]
            var link = pdftest.split('.com/')
            this.urlList.push(link[1])
          }
          modal.style.display = 'none'
          document.getElementById('accountURL').value = response.data[i]
        })
        .catch(e => {
          this.errorslist.push(e)
        })
    },

    getaccountids () {
      httpyodlee
        .get('/account/accountId/' + this.$session.get('user_id'))
        .then(response => {
          this.accountidlist = response.data
          console.log('Response for Account Id : ' + this.accountidlist)
        })
        .catch(e => {
          this.errorslist.push(e)
        })
    },
    getAccountListForMonthChange () {
      this.yodlee.accountid = ''
      console.log('MONTH : ' + this.month)
      if (this.month == 'All' && this.year == 'All') {
        this.getaccountids()
      } else {
        console.log('YEAR : ' + this.year)
        console.log('MONTH : ' + this.month)
        httpyodlee
          .get('/account/linksForMonthChange/' + this.year + '/' + this.month)
          .then(response => {
            this.accountidlist = response.data
            console.log('ACCOUNT LINK  : ' + this.accountidlist)
          })
          .catch(e => {
            this.errorslist.push(e)
          })
      }
    },

    formatCellPhoneNumber: function (event) {
      var phone = this.yodlee.mobile
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.yodlee.mobile = phone
    },
    validateEmail () {
      var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      if (reg.test(this.yodlee.email)) {
        // console.log('Validadtion email' + this.yodlee.email)
        this.message = ''
      } else {
        this.message = 'Please Enter Valid Email'
        this.msgcolor.color = 'Red'
      }
    },
    savecustomerdata: function () {
      //  console.log('route is' + JSON.stringify(window.location.origin))

      this.$validator.validateAll().then(() => {
        console.log('ERROR : ' + this.errors.any())
        if (!this.errors.any()) {
          this.saveyodleedata()
        }
      })
    },

    dis () {
      document.onkeypress = function (event) {
        event = (event || window.event)
        if (event.keyCode == 123) {
          // alert('No F-12');
          return false
        }
      }
      document.onmousedown = function (event) {
        event = (event || window.event)
        if (event.keyCode == 123) {
          // alert('No F-keys');
          return false
        }
      }
      document.onkeydown = function (event) {
        event = (event || window.event)
        if (event.keyCode == 123) {
          // alert('No F-keys');
          return false
        }
      }
    },
    clearMessage () {
      this.message = ''
    },

    saveyodleedata () {
      var secret = 'SeCrET'
      // var secret = this.yodleedatalist[0].keyValue

      let newdata = {
        dealId: this.CryptoJS.AES.encrypt(
          this.yodlee.dealid,
          secret
        ).toString(),
        firstName: this.CryptoJS.AES.encrypt(
          this.yodlee.firstname,
          secret
        ).toString(),
        lastName: this.CryptoJS.AES.encrypt(
          this.yodlee.lastname,
          secret
        ).toString(),
        businessName: this.CryptoJS.AES.encrypt(
          this.yodlee.businessname,
          secret
        ).toString(),
        vehicle: this.CryptoJS.AES.encrypt(
          this.yodlee.mobile,
          secret
        ).toString(),
        customerEmail: this.CryptoJS.AES.encrypt(
          this.yodlee.email,
          secret
        ).toString(),
        middleName: this.CryptoJS.AES.encrypt(
          this.yodlee.middlename,
          secret
        ).toString(),
        vin: this.CryptoJS.AES.encrypt(this.yodlee.zipcode, secret).toString(),
        caEmail: this.CryptoJS.AES.encrypt(
          this.$session.get('user_id'),
          secret
        ).toString()
        // caEmail:'usha.n@syntrino.net',
      }
      var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      if (reg.test(this.yodlee.email)) {
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        httpyodlee
          .post('/account', newdata, { params: {
            Secret: secret }
          })
          .then(response => {
            var status = response.data
            modal.style.display = 'none'
            // console.log("Successfully saved:"+JSON.stringify(status))

            if (response.status == 200) {
              this.message = 'Successfully sent invitation code to customer'
              this.msgcolor.color = 'Blue'
              this.savedmessage = 'Successfully added into the system'
              this.errors.clear()
              this.$validator.reset()
              this.yodlee = this.initializedata()
            } else {
              this.message = 'Data not saved into system'
            }
          })
          .catch(e => {
            console.log('Error in save data: ' + e)
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.message = 'Please Enter Valid Email'
        this.msgcolor.color = 'Red'
      }
    },

    fetchdata () {
      this.getYears()
      this.dis()
      this.getaccountids()
      this.getkeymaster()
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped>
@media only screen and (min-width: 768px) {
  .button {
    border: 1px solid #ddd;
    background-color: dodgerblue;

    color: white;
    cursor: pointer;
    border-radius: 6px;
    font-size: 15px;
    height: 25px;
    width: 12%;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
}
.floating-label {
  position: relative;
  margin-bottom: 20px;
  width: 30%;
  margin-right: 50px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 4px;
  display: block;
  width: 100%;
  height: 30px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #757575;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border-bottom: 2px solid #009688;
}

label {
  color: #999;
  font-size: 15px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 5px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label,
.floating-input:not(:placeholder-shown) ~ label {
  top: -18px;
  font-size: 15px;
  color: #009688;
}

.floating-select:focus ~ label,
.floating-select:not([value=""]):valid ~ label {
  top: -18px;
  font-size: 15px;
  color: #009688;
}
.button-padding {
  padding: 4px 4px 20px 4px !important;
}
/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.floating-textarea {
  min-height: 30px;
  max-height: 260px;
  overflow: hidden;
  overflow-x: hidden;
}

/* highlighter */
.highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.button {
  border: 1px solid #ddd;
  background-color: dodgerblue;

  color: white;
  cursor: pointer;
  border-radius: 6px;
  font-size: 15px;
  height: 25px;
  width: 12%;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.reportLink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}

.modal-height {
  /* width: 656px !important; */
  width: 100% !important;
  border-radius: 10px !important;
}
</style>
